import './bootstrap'
import { createApp } from 'vue'
import * as Sentry from '@sentry/vue';
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './Router'
import VueGtag from 'vue-gtag'
import '../css/app.css'

const app = createApp(App)

Sentry.init({
    app,
    trackComponents: true,
    environment: import.meta.env.VITE_APP_ENVIRONMENT,
    dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
    integrations: [
        new Sentry.BrowserTracing({
            // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
            tracePropagationTargets: ["localhost", /^https:\/\/invoicing\.staging\.lifeworx\.com\/api/, /^https:\/\/invoicing\.lifeworx\.com\/api/],
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        }),
        new Sentry.Replay(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});


const pinia = createPinia()

app.use(pinia)

app.use(router)

app.use(VueGtag, {
    config: {
        id: import.meta.env.VITE_GA_MEASUREMENT_ID,
    }
}, router)

app.mount('#app')
